import { message } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { sgmCustomType } from '@/util/sgm';

// import { RETURN_URL, API_BASE_URL, MESSAGE_DURATION } from '../utils/constants'
import { goLogin } from './common';
import { BUSINESS_STATUS, checkWhitelist } from './common';
import { getLoginType } from '@/util/env';
// import { axiosCreateSignature } from './signature'
// B商城默认的交易四要素参数
const DEFAULT_BIZ_INFO = {
    commonParam: {
        pid: 100, //产品线Id
        verticalCode: 'cn_retail_bmall', //判断业务身份
        ua: 1, //用户终端 PC:1
        language: 'zh', //国际化
        requestId: uuidv4(), //uuid，唯一标识
    },
    clientType: 'PC', //todo 目前职能来不及更改，后续删除
};

export const BASE = process.env.VUE_APP_BASE_COLOR_URL;
export const API_PRE_FIX = '';

/**
 * addRequestConfig
 * axios 请求拦截器方法
 * @param config
 */
export const addRequestConfig = (config = {}) => {
    const { method } = config;
    const isMethodGet = method === 'get';
    // 请求参数 body 对象默认值
    let defaultCommonBodyParams = {
        // ...DEFAULT_BODY_PARAMS,
        // ...DEFAULT_BIZ_INFO,
        // 拦截器中透传 studioConfig
        // ...studioConfig,
        // requestId: new Date().getTime(),
        // t: new Date().getTime(),
        loginType: getLoginType(),
    };
    // 添加白名单逻辑
    // defaultCommonBodyParams = checkWhitelist(config, defaultCommonBodyParams);
    // 添加get 请求，防止缓存操作
    // config = addRequestQuery(config);

    config.headers = Object.assign({}, config.headers, {
        'Access-Control-Allow-Origin': '*',
        'x-requested-with': 'XMLHttpRequest',
    });

    if (!isMethodGet) {
        config.data = Object.assign({}, defaultCommonBodyParams, config.data);
    }
    config.params = Object.assign({}, defaultCommonBodyParams, config.params);
    // FIX 添加query 参数
    // FIX 强行添加 参数 Signature
    // config = axiosCreateSignature(config)
    return config;
};

/**
 * 接口请求成功后，拦截返回值
 * @param response
 * @returns {Promise<never>}
 */
export const addResponseSuccess = (response = {}) => {
    // console.log('success-response ====\n', response)
    // eslint-disable-next-line prefer-const
    let { data, config } = response;
    // TODO data string 情况
    if (typeof data === 'string' && data !== '') {
        data = JSON.parse(data);
    }
    const { code = 0 } = data || {};
    const { params = {} } = config;
    // 是否需要提示，默认是走后端提示
    const { isShowMsg = true, needFilterResult = true } = params;
    // code *= 1
    Object.assign(data, { code });
    // TODO, 未登录暂未实现登录跳转，只给提示
    // 未登录，直接跳转

    const functionId = config?.url;
    const requestParams = config?.data;
    if ([420].includes(code)) {
        // goLogin(loginUrl)
        goLogin();
        console.log('未登录');
        return Promise.reject(data);
    } else if (!BUSINESS_STATUS.SUCCESS.includes(code)) {
        isShowMsg &&
            message.error({
                content: data.errorDesc || data.message || data.msg || '服务异常，请稍后再试！',
            });

        sgmCustomType(
            "warn",
            "30001",
            `${functionId}请求失败，入参：${requestParams}，接口返回：${JSON.stringify(
                data
            )}`
        );
        return Promise.reject(data);
    } else {
        return data;
    }
};

/**
 * 接口请求失败或者出现未知异常，给出错误提示信息
 * @param error
 * @returns {Promise<never>}
 */
export const addResponseError = (error = {}) => {
    console.log('======error==data======\n', error);
    const { status } = error.response || {};
    // 是否登录
    if (BUSINESS_STATUS.NOT_LOGIN.includes(status)) {
        goLogin();
        return Promise.reject(error.response);
    } else if (BUSINESS_STATUS.NOT_HEADID.includes(status)) {
        window.location.href = 'weixin://dl/business/?t=Xai3myEiDmd';
        return Promise.reject(error.response);
    }

    error.message &&
        message.error({
            content: error.message || '未知错误！',
        });
        sgmCustomType("warn", "30001", `上报信息：${JSON.stringify(error)}`);
    return Promise.reject(error);
};

export const addJDDJResponseError = (error = {}) => {
    console.log("======error==data======\n", error);

    error.message &&
        message.error({
            content: `到家运营平台错误：${error.message}` || "到家运营平台未知错误！",
        });
    return Promise.reject(error);
};
